import React, {useEffect, useState} from 'react'
import {AutoComplete, Form, Input, InputNumber, Tag} from "antd";
import {getStockInformation} from "../../services/serviceInventory";
import config from "../../config";

const {Option} = AutoComplete

const ShippingOrderStockWarehouse = ({
                                         stockId,
                                         stockLabel,
                                         handler,
                                         formInstance,
                                         itemInfo,
                                         index,
                                         contentId
                                     }) => {
    const [warehouses, setWarehouses] = useState([])

    useEffect(() => {
        getStockInformation(stockId)
            .then(({data}) => {
                const availableWarehouses = data.map(item => {
                    const warehouse = item.warehouse

                    if (config.currentTenant() === 'gokhan'
                        && warehouse
                        && warehouse.name.toLocaleLowerCase('tr') === 'şerifali'
                    ) {
                        formInstance.setFieldsValue({
                            [`warehouse-${stockId}-${index}`]: `${warehouse.code} - ${warehouse.name}`
                        })
                        handleWarehouseChange(true, {key: warehouse.id})

                    }

                    return {
                        value: warehouse.id,
                        text: `${warehouse.code} - ${warehouse.name}`
                    }
                })
                setWarehouses(availableWarehouses)
            })

        if (formInstance && itemInfo) {
            const selectedWarehouseSource = itemInfo.warehouse
                ? `${itemInfo.warehouse.code} - ${itemInfo.warehouse.name}`
                : ''
            const quantity = itemInfo.quantity || itemInfo.amount
                ? itemInfo.quantity || itemInfo.amount
                : ''
            formInstance.setFieldsValue({
                [`warehouse-${stockId}-${index}`]: selectedWarehouseSource,
                [`quantity-${stockId}-${index}`]: quantity
            })
        }
    }, [stockId])
    const handleWarehouseChange = (v, {key}) => handler(stockId, 'warehouse', {id: key}, index, contentId)
    const handleQuantityChange = ({target}) => handler(stockId, 'quantity', target.value, index, contentId)

    return (
        <React.Fragment>
            <Form.Item
                label={'Depo & Adet'}
            >
                <Input.Group compact>
                    <Form.Item
                        name={`warehouse-${stockId}-${index}`}
                        noStyle
                    >
                        <AutoComplete
                            onChange={handleWarehouseChange}
                            style={{width: '50%', marginRight: '16px'}}
                            placeholder={'Depo Seçiniz'}
                        >
                            {
                                warehouses.map(item => {
                                    return <Option key={item.value} value={item.text}/>
                                })
                            }
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        name={`quantity-${stockId}-${index}`}
                    >
                        <InputNumber
                            min={0}
                            step={0.1}
                            placeholder={'Adet Giriniz'}
                            onBlur={handleQuantityChange}
                            style={{marginRight: '16px'}}/>
                    </Form.Item>
                    <Form.Item noStyle>
                        <Tag color="geekblue">{stockLabel}</Tag>
                    </Form.Item>
                </Input.Group>
            </Form.Item>
        </React.Fragment>
    )
}
export default ShippingOrderStockWarehouse